import { render, staticRenderFns } from "./ViewOrder.vue?vue&type=template&id=5761d34c"
import script from "./ViewOrder.vue?vue&type=script&lang=js"
export * from "./ViewOrder.vue?vue&type=script&lang=js"
import style0 from "./ViewOrder.vue?vue&type=style&index=0&id=5761d34c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports